

























import Component from 'vue-class-component';
import Vue from 'vue';
import { Prop } from 'vue-property-decorator';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import LocalValueInput from '../autocomplete/abstract/LocalValueInput';

@Component
export default class DatePicker extends Vue {
  @Prop({ default: "" }) label!: string;
  @Prop({ default: "" }) value!: string;
  isMenuVisible = false;

  get localValue(): string {
    return this.value;
  }
  set localValue(newValue: string) {
    this.$emit("input", newValue);
  }
}
